import { Section, Eyebrow, Heading } from './home-ui';
import { MediaFrame } from './hero-component';

export default function ServiceArea({ data }) {
    if (!data) return null;
    const { eyebrow, titleLine1, titleLine2, paragraph, counties = [], cities = [], mapImage, mapAlt } = data;

    return (
        <Section id="areas" bg="white">
            <div className="max-w-2xl">
                {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
                <Heading line1={titleLine1} line2={titleLine2} className="mt-4" />
                {paragraph && <p className="mt-4 text-lg text-ink-muted">{paragraph}</p>}
            </div>

            <div className="mt-10 grid grid-cols-1 items-start gap-10 lg:grid-cols-2">
                <MediaFrame src={mapImage} alt={mapAlt} ratio="aspect-[9/5]" label="Map, tri-county coverage" />
                <div>
                    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
                        {counties.map((c) => (
                            <div key={c} className="rounded-card border border-surface-line bg-surface-alt px-4 py-3 text-center font-display font-semibold text-navy">{c}</div>
                        ))}
                    </div>
                    {cities.length > 0 && (
                        <div className="mt-6 flex flex-wrap gap-2">
                            {cities.map((city) => (
                                <span key={city.slug || city.name} className="rounded-full border border-surface-line px-3.5 py-1.5 text-sm text-ink-muted">{city.name}</span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </Section>
    );
}
